import { useUserMetadata } from "lib/store/user"
import { BaseContactPage } from "plugins/Paywall/pages/BaseContactPage"

export function ShareLinkContactPage({ selectedLink, setSelectedLicense }) {
    const userMeta = useUserMetadata() || {}
    if (!userMeta) return null

    const displayName = userMeta.displayName ?? ""
    const email = userMeta.email ?? ""

    const subject = "Enquiry regarding access via ShareLink without a Licence"
    const title = "Contact SFG20 Customer Services"
    const description =
        "To view this shared content, you need a valid Licence. Please contact the organisation that shared this link with you, or contact SFG20 Customer Services to discuss access options."

    const clientName = selectedLink?.contact?.companyName || "Unknown Organisation"
    const creatorName = selectedLink?.contact?.displayName || ""
    const linkLabel = selectedLink?.name || "Unnamed Link"
    const label = creatorName ? `${clientName} (${creatorName})` : clientName

    const message = `Hello,<br />I received a valid SFG20 share link (${linkLabel}) from ${label} but do not have an active Licence. Please advise on how I can gain access.<br />Regards,<br />${displayName}${email ? `<br />${email}` : ""}`

    return (
        <BaseContactPage formContents={{ subject, message }} title={title} description={description} onBack={onBack} />
    )

    function onBack() {
        setSelectedLicense(undefined)
    }
}
